var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from '@tanstack/react-query';
import { ELSTokenHelper } from 'components/common';
import { checkPathMatchV2 } from 'helpers/app.helper';
import { SystemType } from 'models';
import { useCallback, useLayoutEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { appActions, appSelectors } from 'redux/ducks/app';
import { HAD_PATHS } from 'reports/had/constants/had.constant';
import { hadActions } from 'reports/had/redux/ducks/had';
import { PS_PATHS } from 'reports/ps/constants';
import { psActions } from 'reports/ps/redux/ducks/ps';
import { fetchCrosswalkUser } from 'services/user-management.service';
// 3395138 is demo user id (in HRND)
var demoEvolveUserId = 3395138;
var CROSSWALK_STALE_TIME = 1000 * 60;
var DemoInit = function () {
    var dispatch = useDispatch();
    var loggedInUser = useSelector(appSelectors.getLoggedInUser);
    var evolveUser = useSelector(appSelectors.getEvolveUser);
    var isMaskUserData = ((loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.appParams) || {}).isMaskUserData;
    var userData = {
        userId: null,
        id: null
    };
    var token = ELSTokenHelper.getToken();
    if (token) {
        userData = ELSTokenHelper.getUserInfoFromToken(token);
    }
    var isHadPath = checkPathMatchV2(__spreadArray([], Object.values(HAD_PATHS), true));
    var isPsPath = checkPathMatchV2(__spreadArray([], Object.values(PS_PATHS), true));
    var eolsId = isHadPath && isMaskUserData ? demoEvolveUserId : userData.userId || userData.id;
    var enabledCrosswalk = useMemo(function () {
        if (!token || !eolsId || !evolveUser) {
            return false;
        }
        var _a = evolveUser.eolsUserIdsByUserNameAndType, eolsUserIdsByUserNameAndType = _a === void 0 ? [] : _a;
        return !eolsUserIdsByUserNameAndType.includes(eolsId);
    }, [eolsId, evolveUser, token]);
    var condition = enabledCrosswalk && !!isMaskUserData;
    var data = useQuery({
        queryFn: function () { return fetchCrosswalkUser(eolsId, SystemType.EVOLVETYPE); },
        queryKey: ['crosswalkUser', 'HRND', eolsId, SystemType.EVOLVETYPE],
        enabled: !!condition,
        keepPreviousData: true,
        staleTime: CROSSWALK_STALE_TIME
    }).data;
    var onCrosswalkUserSuccess = useCallback(function (res) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dispatch(appActions.setEvolveUsername((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.userName))];
                case 1:
                    _b.sent();
                    dispatch(hadActions.setPrograms([]));
                    dispatch(appActions.setEvolveUser(res === null || res === void 0 ? void 0 : res.data));
                    if (isHadPath) {
                        dispatch(hadActions.fetchHESIDashboardData());
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, isHadPath]);
    useLayoutEffect(function () {
        if (data) {
            onCrosswalkUserSuccess(data);
        }
    }, [data, onCrosswalkUserSuccess]);
    useQuery({
        queryKey: ['crosswalkUser', 'PS', eolsId, SystemType.EVOLVETYPE],
        queryFn: function () { return fetchCrosswalkUser(String(demoEvolveUserId), SystemType.EVOLVETYPE); },
        enabled: isPsPath && !!isMaskUserData,
        onSuccess: function (res) {
            var _a;
            dispatch(psActions.setHadDemoEvolveUsername((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.userName));
        }
    });
    return null;
};
export default DemoInit;
